import React from 'react';
import Alert from 'components/shared/Alert';

const AIAlert = ({ tooltipText }) => {
  return (
    <Alert icon="info">
      {t('actions.ai.ai_powered')}{' '}
      <span
        className="bold-underline"
        data-toggle="tooltip"
        title={tooltipText}
        data-placement="top"
        role="button"
        tabIndex="0"
      >
        {t('actions.ai.learn_more')}
      </span>
    </Alert>
  );
};

export default AIAlert;
